import { OffsetDateTime } from "@js-joda/core";
import { BloodGlucoseForm, BloodGlucoseFormApiDto, toBloodGlucoseForm } from "./BloodGlucoseForm";
import {
  BloodGlucoseReading,
  BloodGlucoseReadingApiDto,
  toBloodGlucoseReading,
} from "./BloodGlucoseReading";

export type BloodGlucoseObservation = {
  id: string;
  dateTime: OffsetDateTime;
  reading?: BloodGlucoseReading;
  form?: BloodGlucoseForm;
};

export type BloodGlucoseObservationDto = {
  dateTime: string;
  reading?: BloodGlucoseReadingApiDto;
  form?: BloodGlucoseFormApiDto;
};

export const toBloodGlucoseObservation = ({
  dateTime,
  reading,
  form,
}: BloodGlucoseObservationDto): BloodGlucoseObservation => ({
  id: [reading?.id, form?.id].filter(Boolean).join("-"),
  dateTime: OffsetDateTime.parse(dateTime),
  reading: reading ? toBloodGlucoseReading(reading) : undefined,
  form: form ? toBloodGlucoseForm(form) : undefined,
});
